export default __webpack_public_path__ + "static/media/pomos1.c9bebc9f.png";